import React, { memo } from 'react';
import get from 'lodash/get';
import ActiveIcon from 'assets/field_matching_menu_icon_active.svg';
import ActiveBadgedIcon from 'assets/field_matching_menu_icon_active_badged.svg';
import InactiveIcon from 'assets/field_matching_menu_icon_inactive.svg';
import InactiveBadgedIcon from 'assets/field_matching_menu_icon_inactive_badged.svg';
import { useMisalignmentsCount } from 'views/FieldMatching/hooks/use-misalignment-count.hook';
import { useTranslation } from 'react-i18next';

type FieldMatchingMenuIconProps = {
  className?: string;
  selected: boolean;
};

const IconSet = {
  active: {
    default: ActiveIcon,
    badged: ActiveBadgedIcon,
  },
  inactive: {
    default: InactiveIcon,
    badged: InactiveBadgedIcon,
  },
};

const FieldMatchingMenuIcon = memo(({ selected, className }: FieldMatchingMenuIconProps) => {
  const { t } = useTranslation();
  const misalignmentCount = useMisalignmentsCount();
  const hasMisalignments = (misalignmentCount ?? 0) > 0;
  const activeStatus = selected ? 'active' : 'inactive';
  const notificationStatus = hasMisalignments ? 'badged' : 'default';
  const status = `${activeStatus}.${notificationStatus}`;
  const imgSrc = get(IconSet, status);
  const altText = t(`field_matching.menu.icon.${status}`);

  return <img className={className} src={imgSrc} alt={altText} />;
});

export default FieldMatchingMenuIcon;
